export const DELAY_TO_SUBMIT = 400;
